<template>
  <div>
    <b-button :size="size" :type="type" @click="getLesson">
        <b>{{text}}</b>
    </b-button>
    <b-modal :active.sync="isModalActive"
              has-modal-card full-screen :can-cancel="false">
              <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
              <pdf-viewer :title="text" :url="lesson.url" v-if="!isLoading  &&  lesson"/>
        </b-modal>
  </div>
</template>

<script>
import PdfViewer from '@/components/PDFViewer'
import LessonService from '@/services/LessonService.js'

export default {
  components: {
    PdfViewer
  },
  props: {
    size: {
      required: false,
      type: String,
      default: 'is-small'
    },
    type: {
      required: false,
      type: String,
      default: 'is-light'
    },
    lessonId: {
      required: true,
      type: Number
    },
    text: {
      required: false,
      type: String,
      default: 'Lección'
    }
  },
  data () {
    return {
      isLoading: false,
      isModalActive: false,
      lesson: null
    }
  },
  methods: {
    async getLesson () {
      this.isLoading = true
      this.isModalActive = true
      let response = await LessonService.getLesson(this.lessonId)
      this.lesson = response.data.data
      this.isLoading = false
    }
  }
}
</script>
